import { RowDeviceRechargeDto } from "@/dtos";
import { DeviceRecharge } from "@/entities";
import { getDeviceRechargeTypeLabel } from "@/helpers/options";
import { formatToCurrency, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowDeviceRechargeDto = (deviceRecharges: DeviceRecharge[]): RowDeviceRechargeDto[] => {
    return deviceRecharges.map((x) => {
        const row: RowDeviceRechargeDto = {
            ...x,
            data_label: parseToLocalDateTimeFromUtc(x.date),
            recharger_label: x.recharger.name,
            system_label: x.plan_details.system,
            plan_label: x.plan_details.plan,
            type_label: getDeviceRechargeTypeLabel(x.type),
            balance_label: `$ ${formatToCurrency(x.balance)}`,
            commision_label: `$ ${formatToCurrency(x.commision)}`,
            total_balance_label: `$ ${formatToCurrency(x.total_balance)}`,
            before_balance_label: `$ ${formatToCurrency(x.before_balance)}`,
            current_balance_label: `$ ${formatToCurrency(x.current_balance)}`,
            is_reverse_label: x.is_reverse ? 'Si' : 'No'
        }

        return row;
    });
}